import { Groups, Person } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

import type React from 'react'

type Props = {
  servesAmount: string
}

export const ServesLabel: React.FC<Props> = ({ servesAmount }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {Number(servesAmount) > 1 ? (
      <Groups color="disabled" fontSize="small" />
    ) : (
      <Person color="disabled" fontSize="small" />
    )}
    <Typography variant="body3">{`Serves ${servesAmount}`}</Typography>
  </Box>
)
